import { render } from "./OsPage.vue?vue&type=template&id=06001cdd&scoped=true"
import script from "./OsPage.vue?vue&type=script&lang=js"
export * from "./OsPage.vue?vue&type=script&lang=js"

import "./OsPage.vue?vue&type=style&index=0&id=06001cdd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06001cdd"]])

export default __exports__